import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";
import AppLogo from "../../core/app-logo";
import FooterLinks from "../../core/footer-links";
import { ArrowForward } from "@mui/icons-material";
import { USER_ROLES } from "../../utils/constants";
import { getOfflineData } from "../../utils/offline-services";
import { Box, Button, Typography } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (getOfflineData("user")) {
      redirection(getOfflineData("user"));
    }
  }, []);

  const redirection = (user) => {
    if (user.role === USER_ROLES.OEM) {
      navigate("/oem");
    } else {
      navigate("/admin");
    }
  };

  return (
    <div className="home-container page-load">
      <img
        src={require("../../resources/icons/logo.png")}
        alt="logo"
        width={70}
      />

      <div className="login-con">
        <div className="login-left">
          <Box sx={{ display: "grid", gridGap: "25px" }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: 600, textAlign: "center" }}
            >
              Select module to begin with
            </Typography>
            <Button
              variant="contained"
              fullWidth
              onClick={() => navigate("/login/user")}
              sx={{ textTransform: "capitalize" }}
            >
              SIMPSONS Login
            </Button>
            <Button
              variant="contained"
              fullWidth
              onClick={() => navigate("/login/OEM")}
              sx={{ textTransform: "capitalize" }}
            >
              OEM Login
            </Button>
          </Box>
        </div>

        <div className="login-right si-hide-mobile">
          <Box sx={{ display: "flex", justifyContent: "space-around" }}>
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <FiberManualRecordIcon sx={{ mr: 1 }} />
              PROACTIVE
            </Typography>
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <FiberManualRecordIcon sx={{ mr: 1 }} /> INNOVATIVE
            </Typography>
            <Typography
              variant="h6"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <FiberManualRecordIcon sx={{ mr: 1 }} /> CUSTOMER CENTRIC
            </Typography>
          </Box>
          {/* <Typography variant="h4" sx={{ mt: 10 }}>
            Good works are <br />
            waiting for you
          </Typography> */}
          <div className="engine-con">
            <img
              src={require("../../resources/icons/watermark.png")}
              alt="Simpson engine image"
              className="engine-image"
            />
          </div>
          <Typography variant="h5" sx={{ textAlign: "center" }}>
            Engineered for Performance, Supported with Care
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Home;
